import React from 'react'
import { orionSystem } from '../../../../../api/integrations'
import OpalCard from '../../../../opal/OpalCard'
import Loading from '../../../../molecules/Loading'
import Source from './Source'

function OrionSystemIntegrations () {
  const { data, isLoading } = orionSystem.useConnectionInfo()

  if (isLoading) {
    return (
      <OpalCard size='md'>
        <header className='font-size-md'>Integration Configuration</header>
        <Loading />
      </OpalCard>
    )
  }

  return (
    <OpalCard size='md'>
      <header className='font-size-md'>Integration Configuration</header>
      {(data?.systemConfiguration?.configuration?.sources || []).map(source => (
        <Source key={source.sourceKey} source={source} />
      ))}
    </OpalCard>
  )
}

export default OrionSystemIntegrations
